
import store from "../../../store";
import { setAllUsers, setDisplayErrorSnackBar, setIsLoading } from "../../../features/userSlice";
import { setAllTrafficSources, setCurrencies, setManualExpenseData } from "../../../features/manualExpenseSlice";
import { manualExpenseService } from "../../../services/api/manual-expense.endpoints";

async function getManualExpenseContent(
  oauthTokenHeader: string,
  setIsLoading: any,
  dispatch: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.getManualExpenseTableContent(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      // setRows(response?.data); // Set the fetched data
      dispatch(setManualExpenseData(response?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getCurrencies(oauthTokenHeader: string, setCurrencies: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.getCurrencies(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    }
    setCurrencies(response?.data?.data); // Set the fetched data
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createExpense(
  oauthTokenHeader: string,
  data: any,
  setExpense: any,
  trackPromise: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.createExpense(
      oauthTokenHeader,
      data
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to get page content");
    }
    setExpense(response?.data?.data); // Set the fetched data
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function editExpense(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: string,
  trackPromise: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.editExpense(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to edit expense");
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function postCommentForManualExpenses(oauthTokenHeader: any, data: any, objectSharedUid: any) {
  try {
    const response = await manualExpenseService.postCommentME(oauthTokenHeader, data, objectSharedUid);
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to post comment action items");
    } else {
      //store.dispatch(setDisplayErrorSnackBar({ message: "Comment has been updated", type: 'success' }))
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function postComment(oauthTokenHeader: any,data: any,object_shared_uid: any,) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.postCommentME(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to post comment");
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function fileUploadME(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: string,
  trackPromise: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.fileUploadME(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload file");
    }
  } catch (e: any) {
    trackPromise(
      store.dispatch(
        setDisplayErrorSnackBar({
          message: e?.parsedText || "Unknown error occurred",
          type: "error",
        })
      )
    );
  }
}

async function getFiles(
  oauthTokenHeader: string,
  object_shared_uid: string,
  setFiles: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.getFiles(
      oauthTokenHeader,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      setFiles([]);
      throw new Error("Failed to get files");
    } else {
      setFiles(response?.data?.data);
    }
  } catch (e: any) {
    // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
  }
}

async function getComments(oauthTokenHeader: string, object_shared_uid: any, setUploadedComments: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.getComments(oauthTokenHeader, object_shared_uid);
    if (!response || !response.status || response.status !== 200) {
      setUploadedComments([]);
      throw new Error("Failed to get comments");
    } else {
      setUploadedComments(response?.data?.data);
    }
  } catch (e: any) {
    // trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || 'Unknown error occurred', type: 'error' })));
  }
}

async function putCommentsForManualExpenses(oauthTokenHeader: any, data: any, objectSharedUid: any) {
  try {
    const response = await manualExpenseService.putComments(oauthTokenHeader, data, objectSharedUid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function deleteCommentForManualExpenses(oauthTokenHeader: any, objectSharedUid: any, commentId: any) {
  try {
    const response = await manualExpenseService.deleteComment(oauthTokenHeader, objectSharedUid, commentId);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to delete comment");
    } else {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", })
    );
  }
}

async function uploadFileForManualExpenses(oauthTokenHeader: any, data: any, object_shared_uid: any) {
  try {
    const response = await manualExpenseService.fileUploadME(oauthTokenHeader, data, object_shared_uid);
    if (!response || !response.status || response.status !== 201) {
      throw new Error("Failed to upload files");
    } else {
      return response?.data?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function deleteFileForManualExpenses(oauthTokenHeader: any, file_shared_uid: any) {
  try {
    const response = await manualExpenseService.deleteFile(oauthTokenHeader, file_shared_uid);
    if (!response || !response.status) {
      throw new Error("Failed to delete file");
    } else if (response.status === 204) {
      return response?.data;
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function putComments(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: string,
  setSuccess: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.putComments(
      oauthTokenHeader,
      data,
      object_shared_uid
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comments");
    } else {
      setSuccess(response?.reason);
    }
  } catch (e: any) {
      store.dispatch(setDisplayErrorSnackBar({message: e?.parsedText || "Unknown error occurred",type: "error",}));
  }
}

async function deleteExpanse(oauthTokenHeader: any, shared_uid: any, setSuccess: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.deleteExpense(oauthTokenHeader, shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update comments");
    } else {
      setSuccess(response?.reason);
      store.dispatch(setDisplayErrorSnackBar({ message: "Delete Successful", type: "success", }));
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getAllUserList(oauthTokenHeader: any) {
  try {
    const response = await manualExpenseService.getAllUsers(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get users");
    } else {
      store.dispatch(setAllUsers(response?.data?.data)); // Set the fetched data
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
};

async function getManualExpenseData(oauthTokenHeader: any, dispatch: any) {
  try {
    const response = await manualExpenseService.getManualExpenseTableContent(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get activity notes");
    } else {
      dispatch(setManualExpenseData(response?.data?.data));
    }
  } catch (e: any) {
    dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getTrafficSource(oauthTokenHeader: string) {
  try {
    const response = await manualExpenseService.getTrafficSource(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      store.dispatch(setDisplayErrorSnackBar({ message: "Something went wrong while Getting Page Content", type: "error", }));
    } else {
      store.dispatch(setAllTrafficSources(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function getCurrency(oauthTokenHeader: string, dispatch: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await manualExpenseService.getCurrencies(oauthTokenHeader);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    }
    dispatch(setCurrencies(response?.data?.data));
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function createNewExpense(oauthTokenHeader: string, data: any) {
  try {
    const response = await manualExpenseService.createExpense(oauthTokenHeader, data);
    if (response.status === 200) {
      return response?.data;
    } else if (response.status === 201) {
      return response?.data;
    } else {
      return { reason: `Unexpected status code: ${response.status}` };
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

async function updateManualExpenseData(oauthTokenHeader: string, data: any, shared_uid: any) {
  try {
    const response = await manualExpenseService.editExpense(oauthTokenHeader, data, shared_uid);
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to update manual expense data");
    } else {
      store.dispatch(setDisplayErrorSnackBar({ message: "Manual expense data updated successfully", type: "success", }));
      return response; // Return the response
    }
  } catch (e: any) {
    store.dispatch(setDisplayErrorSnackBar({ message: e?.parsedText || "Unknown error occurred", type: "error", }));
  }
}

// eslint-disable-next-line
export const ManualExpenseEndPointLogic = {
  getManualExpenseContent,
  getCurrencies,
  createExpense,
  editExpense,
  postComment,
  fileUploadME,
  getFiles,
  getComments,
  postCommentForManualExpenses,
  putCommentsForManualExpenses,
  deleteCommentForManualExpenses,
  uploadFileForManualExpenses,
  deleteFileForManualExpenses,
  putComments,
  getManualExpenseData,
  getAllUserList,
  getTrafficSource,
  getCurrency,
  createNewExpense,
  updateManualExpenseData,
  deleteExpanse,
};
